import { Controller } from 'react-hook-form';
import React from 'react';
import PropTypes from 'prop-types';

const RadioOptionField = ({ name, label, isChecked, value, control }) => {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { onChange, onBlur, ref, ...props } }) => (
                <>
                    <label className={'d-flex align-items-start pt-2'}>
                        <input
                            { ...props }
                            id={name}
                            ref={ref} // set ref for focus management
                            type="radio"
                            name={name}
                            className='radio-input'
                            value={value}
                            onChange={(e) => onChange(e.target.value)} // send value to hook form
                            checked={isChecked}
                        />
                        {label}
                    </label>
                </>
            )}
        />
    );
};

RadioOptionField.propTypes = {
    name: PropTypes.string,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    value: PropTypes.string,
    control: PropTypes.object,
    isChecked: PropTypes.bool,
};

RadioOptionField.defaultProps = {
    name: '',
    value: '',
    isChecked: false,
};

export default RadioOptionField;
